/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_Metric_E1rm_HintInputs */

const en_us2_exercise_personal_goal_metric_e1rm_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The weight you could lift once. The app works it out from your best set, so you never have to test it.`)
};

const pt_br2_exercise_personal_goal_metric_e1rm_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso que você levantaria uma única vez. O app calcula pela sua melhor série, sem você precisar testar.`)
};

const es_419_exercise_personal_goal_metric_e1rm_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El peso que podrías levantar una sola vez. La app lo calcula a partir de tu mejor serie, sin que tengas que probarlo.`)
};

const pt_pt2_exercise_personal_goal_metric_e1rm_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso que levantarias uma única vez. A app calcula-o a partir da tua melhor série, sem precisares de o testar.`)
};

const fr_fr2_exercise_personal_goal_metric_e1rm_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La charge que tu pourrais soulever une seule fois. L'app la calcule à partir de ta meilleure série, sans que tu aies à la tester.`)
};

const de_de2_exercise_personal_goal_metric_e1rm_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Gewicht, das du einmal heben könntest. Die App berechnet es aus deinem besten Satz, du musst es also nie testen.`)
};

const it_it2_exercise_personal_goal_metric_e1rm_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il peso che potresti sollevare una sola volta. L'app lo calcola dalla tua serie migliore, così non devi mai testarlo.`)
};

/**
* | output |
* | --- |
* | "The weight you could lift once. The app works it out from your best set, so you never have to test it." |
*
* @param {Exercise_Personal_Goal_Metric_E1rm_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_metric_e1rm_hint = /** @type {((inputs?: Exercise_Personal_Goal_Metric_E1rm_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Metric_E1rm_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_metric_e1rm_hint(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_metric_e1rm_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_metric_e1rm_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_metric_e1rm_hint(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_metric_e1rm_hint(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_metric_e1rm_hint(inputs)
	return en_us2_exercise_personal_goal_metric_e1rm_hint(inputs)
});
export { exercise_personal_goal_metric_e1rm_hint as "exercise-personal.goal_metric_e1rm_hint" }